<!-- eslint-disable -->
<template lang="pug">
    .row.school-preview
        .col-xs-10.col-sm-11.school-preview__column.school-preview__column_hide-name
            .school-preview__item
                .school-preview__avatar
                    svg-icon.school-preview__icon(name="gift", size="x-large")
                div
                    router-link.preview__text.preview__text_large.school-preview__link.school-preview__link_large(
                        :to="{name: 'stocks:edit', params: {id: stock.id}}"
                    )
                        | {{ stock.name }}
                    .preview__text.preview__text_large.preview__text_subtitle
                        div(v-if="stock.description") {{ stock.description }}
                        div(v-else) {{ $i18n.t('list.list_preview_noDescription') }}
        .col-xs-2.col-sm-1.last-xl.end-xs.school-preview__column
            dropdown(:icon="false" without-move)
                template(slot="link")
                    svg-icon.school-preview__icon.school-preview__icon_blue(name="select", :size="selectorSize")
                ul.dropdown__links
                    li.dropdown__link
                        router-link.school-preview__link(
                            :to="{name: 'stocks:edit', params: {id: stock.id, type: 'stocks', copy: stock}}"
                        )
                            | {{ $i18n.t('list.list_common_actionsEdit') }}
                    li.dropdown__link
                        router-link.school-preview__link(
                            :to="{name: 'stocks:create', params: {copy: stock, type: 'stocks'}}"
                        )
                            | {{ $i18n.t('list.list_homeworkPreview_actionsCopy') }}
                    li.dropdown__link
                        a(
                            href="javascript://"
                            @click="displayConfirmDeleteModal = true"
                        )
                            | {{ $i18n.t('list.list_common_actionsDelete') }}
        .col-xs-12.col-sm-11.user-preview__column
            .school-preview__name
                .school-preview__avatar
                    svg-icon.school-preview__icon(name="gift", size="x-large")
                div
                    router-link.preview__text.preview__text_large.school-preview__link.school-preview__link_large(
                        :to="{name: 'stocks:edit', params: {id: stock.id}}"
                    )
                        | {{ stock.name }}
                    .preview__text.preview__text_large.preview__text_subtitle
                        div(v-if="stock.description") {{ stock.description }}
                        div(v-else) {{ $i18n.t('list.list_preview_noDescription') }}
            .row.school-preview__info
                .col-xl-6.info__column
                    .school-preview__items.school-preview__items_columned
                        .school-preview__item
                            svg-icon.school-preview__icon(v-if="getStockStatus() === 'Active'" name="check")
                            svg-icon.school-preview__icon(v-else name="cancel")
                            .preview__text {{ getStatusName() }}
                        .school-preview__item
                            svg-icon.school-preview__icon(name="calendar")
                            .preview__text
                                | {{ $i18n.t('list.list_preview_period') }}:
                                | {{ stock.start | moment('DD.MM.YYYY') }} - {{ stock.end | moment('DD.MM.YYYY') }}
                        .school-preview__item
                            svg-icon.school-preview__icon(name="login")
                            .preview__text
                                | {{ $i18n.t('list.list_stockPreview_for') }}:&nbsp;
                                span(v-if="stock.for_student_payed_schools") {{ $i18n.t('list.list_stockPreview_forSchools') }}
                                span(v-else) {{ $i18n.t('list.list_stockPreview_forStudents') }}
                .col-xl-6.info__column
                    .school-preview__items.school-preview__items_columned
                        .school-preview__item
                            svg-icon.school-preview__icon.school__avatar(name="university", size="x-large")
                            .school__info
                                .school__type
                                    | {{ $i18n.t('list.list_preview_schools') }}
                                    span.school__angle(
                                        v-if="stock && stock.schools && stock.schools.length > 5"
                                        @click="showHideSchools"
                                    )
                                        svg-icon.school__icon(
                                            name="angle",
                                            :class="{'rotate-icon': showSchools}"
                                            size="base",
                                        )
                                router-link.school__name(
                                    v-for='school in shownSchools'
                                    :key="school.id"
                                    :to="{name: 'school:profile', params: {id: school.id}}"
                                )
                                    | {{ school.name }}
                                .school__name(v-if="stock.schools.length > shownSchools.length")
                                    | ...
        confirm-delete-modal(v-if="displayConfirmDeleteModal"
            @close="displayConfirmDeleteModal = false"
            @delete="$emit('delete', profile.id)"
        )
            | {{ " " + $i18n.t('list.list_preview_deleteStockModal') }} "{{ profile.name }}"
</template>

<script>
    /*eslint-disable*/
    import Dropdown from "../../../../elements/Dropdown.vue";
    const ConfirmDeleteModal = () => import('../../../../modals/ConfirmDeleteModal.vue');
    import moment from 'moment'

    const MAX_AMOUNT_OF_SHOWED_SCHOOLS = 5;

    export default {
        props: {
            profile: Object
        },
        data () {
            return {
                showSchools: false,
                displayConfirmDeleteModal: false
            }
        },
        methods: {
            showHideSchools () {
                this.showSchools = !this.showSchools;
            },
            getStockStatus () {
                let today = moment();
                if (moment(this.stock.end).isSameOrAfter(today) && moment(this.stock.start).isSameOrBefore(today)) {
                    return 'Active'
                }
                if (moment(this.stock.end).isBefore(today)) {
                    return 'Archived';
                }
                if (moment(this.stock.start).isAfter(today)) {
                    return 'Upcoming';
                }
            },
            getStatusName () {
                return this.$i18n.t('fields.fields_status' + this.getStockStatus());
            }
        },
        computed: {
            stock () {
                return this.profile;
            },
            shownSchools () {
                if (this.stock && this.stock.schools && this.stock.schools.length > MAX_AMOUNT_OF_SHOWED_SCHOOLS && !this.showSchools) {
                    return this.stock.schools.slice(0, MAX_AMOUNT_OF_SHOWED_SCHOOLS);
                }
                return this.stock.schools;
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            },
            schoolsTooltip () {
                return this.stock.schools.slice(MAX_AMOUNT_OF_SHOWED_SCHOOLS).map(element => element.name).join('\n');
            }
        },
        components: {
            Dropdown,
            ConfirmDeleteModal
        },
    }
</script>

<style scoped lang="scss">
    .middle {
        vertical-align: middle;
        padding-left: 5px;
    }

    .archived {
        background: #d3d3d3;
    }

    .upcoming {
        background: #ebebeb;
    }

    .dropdown {
        display: block;
        z-index: 0;
        padding: 0;
        box-shadow: none;
        background: none;
        border: medium none transparent;
        &::after {
            content: normal;
            width: 0;
        }
    }

</style>

<style lang="scss" scoped>
    .school-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .school-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin-bottom: 8px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .school-preview__column:last-child {
        margin-bottom: 0;
    }

    .school-preview__column:first-child {
        margin-bottom: 16px;
    }

    .school-preview__column_hide-name {
        @include media($xlg) {
            display: none;
        }
    }

    .school-preview__column_show-name {

    }

    .school-preview__name {
        margin-bottom: 16px;
        display: none;
        align-items: center;
        @include media($xlg) {
            display: flex;
        }
    }

    .school-preview__avatar {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: $border-radius-circle;
        background-color: #F3F8EF;
    }

    .school-preview__icon {
        color: $hsl-color-green-58;
    }

    .school-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .school-preview__items {
        display: flex;
        margin: -4px 0;
    }

    .school-preview__items_columned {
        flex-direction: column;
    }

    .school-preview__item {
        display: flex;

        font-size: 13px;
        line-height: 16px;

        padding: 4px;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .school-preview__link {
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school-preview__item:not(:last-child) {
        margin-bottom: 8px;
    }

    .school-preview__info {
        margin: -8px 0;
    }

    .info__column {
        padding: 8px 0;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .preview__text_subtitle {
        margin-top: 8px;
    }

    .school-preview__link {
        display: flex;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school-preview__link_large {
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .custom-dropdown {
        top: 0;
        left: 0;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .school {
        display: flex;
        align-items: center;
        font-size: 13px;
        line-height: 16px;
    }

    .school__avatar {
        padding-top: 8px;
        margin-right: 12px;
    }

    .school__info {
        display: flex;
        flex-direction: column;
    }

    .school__name {
        margin-top: 8px;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school__type {
        color: $x-color-black;
        text-decoration: none;
        font-weight: 500;
    }

    .school__icon {
        color: $hsl-color-green-58;
        transition: transform .2s ease;
    }

    .school__angle {
        margin-left: 8px;
        cursor: pointer;
    }

    .rotate-icon {
        transform: rotate(180deg);
    }
</style>
